import React from 'react';
import { SideNavCategory, SideNavColorScheme } from '..';
import * as Styled from './styled';

interface NoItemsProps {
  colorScheme: SideNavColorScheme;
  subCategory: SideNavCategory;
}

const formattedCategory = {
  Recents: 'recently used',
  Favorites: 'favorite',
  Saved: 'saved',
};

const formattedSubCategoryType = {
  RecentReport: 'reports',
  SavedReport: 'reports',
  SharedReport: 'reports',
};

export const NoItemsToDisplay = ({
  colorScheme,
  subCategory,
}: NoItemsProps): JSX.Element => {
  const formattedSubCategory =
    formattedSubCategoryType[subCategory?.typeName] || 'fields';
  const suffixMessage = subCategory.customSuffixMessage
    ? `${formattedSubCategory} ${subCategory.customSuffixMessage}`
    : `${formattedSubCategory} to
  display.`;
  return (
    <Styled.NoItemsToDisplay colorScheme={colorScheme}>
      No {formattedCategory[subCategory.name]} {suffixMessage}
    </Styled.NoItemsToDisplay>
  );
};
